import { Button, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import { useFormik } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import { LoadingButton } from "@mui/lab";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import service from "../../service/Service";
import passTemplate1 from "../../assets/pass-templates/Invite1.jpeg";
import DownloadIcon from "@mui/icons-material/Download";
import { PublicURLImages } from "../../config";

const validationSchema = yup.object({
  TeamName: yup
    .string("Add your Team Members")
    .required("Team Members is required"),
});

export const TeamDetails = () => {
  const dispatch = useDispatch();
  const [loadingbtn, Setloadinbtn] = useState(false);
  const myAllData = useSelector((state) => state.Alldata.data);

  const [getstudents, Setstudents] = useState([]);
  const [saveStudentStates, setSaveStudentStates] = useState([]); // raw students
  const [posterPreviews, setPosterPreviews] = useState([]); // posters blob urls

  const formik = useFormik({
    initialValues: {
      TeamName: myAllData.TeamName || myAllData.team_name || "",
      TeamMember: myAllData.TeamMember || myAllData.team || [],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch({ type: "next", payload: true });
      dispatch({
        type: "addxyz",
        payload: values,
      });
    },
  });

  const GetAllStudents = () => {
    let role = localStorage.getItem("role");
    if (role === "xxst") {
      service.get(`team-members`).then((res) => {
        let { students } = res.data;
        Setstudents(students);
      });
    } else if (role === "xxca") {
      service.get(`team-member-by-center`).then((res) => {
        let { students } = res.data;
        Setstudents(students);
      });
    }
  };

  React.useEffect(() => {
    GetAllStudents();
  }, []);

  function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(" ");
    let line = "";
    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + " ";
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        ctx.fillText(line, x, y);
        line = words[n] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line, x, y);
    return y + lineHeight; // return new Y position
  }

  const getPosters = async (members) => {
    setSaveStudentStates(members);

    // generate posters on selection
    const posters = await Promise.all(
      members.map(async (m) => {
        const file = await generateNameImage(m);
        return { student: m, file, url: URL.createObjectURL(file) };
      })
    );
    setPosterPreviews(posters);
  };

  async function generateNameImage(values, options = {}) {
    console.log(`${PublicURLImages}${values.std_profile_image}`);
    return new Promise((resolve, reject) => {
      // ✅ Check profile image before generating
      if (!values.std_profile_image || values.std_profile_image === "") {
        alert(`❌ Poster not generated for ${values.std_name} — no profile picture available.`);
        return reject(`No profile image for ${values.std_name}`);
      }

      const img = new Image();
      img.src = passTemplate1;

      img.onload = async () => {
        const targetWidth = 800;
        const targetHeight = Math.round((img.height / img.width) * targetWidth);

        const canvas = document.createElement("canvas");
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("Failed to get canvas context");

        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

        // ✅ Draw profile image
        await new Promise((res, rej) => {
          const profileImg = new Image();
          //annonymous access to avoid CORS issues
          profileImg.crossOrigin = "anonymous"; 
          profileImg.src = PublicURLImages +'users/'+ values.std_profile_image;
          profileImg.onload = () => {
            const profileSize = 180;
            const profileX = 610;
            const profileY = 130;
            ctx.save();
            ctx.beginPath();
            ctx.arc(
              profileX + profileSize / 2,
              profileY + profileSize / 2,
              profileSize / 2,
              0,
              Math.PI * 2,
              true
            );
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(profileImg, profileX, profileY, profileSize, profileSize);
            ctx.restore();
            res(true);
          };
          profileImg.onerror = rej;
        });

        // ✅ Text rendering
        ctx.fillStyle = options.color || "#ffffff";
        ctx.font = `bold ${options.fontSize || 28}px Helvetica`;
        ctx.textAlign = options.align || "left";

        ctx.fillText(values.std_name?.toUpperCase(), 360, 70);
        wrapText(ctx, "Aptech Metro Stargate Center Karachi", 360, 100, 400, 35);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject("Failed to create blob");
            resolve(new File([blob], "Poster.png", { type: "image/png" }));
          },
          "image/png",
          0.8
        );
      };
      img.onerror = reject;
    });
  }


  function downloadFile(file, filename) {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(file);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  return (
    <div>
      <div className="grandContainer">
        <div className="FormContainer">
          <div className="innerContainer">
            <p className="formTitle" style={{ color: "#AB509D" }}>
              Team Details
            </p>
            <form onSubmit={formik.handleSubmit}>
              <div className="innerGroup">
                <p>Team Name</p>
                <TextField
                  id="TeamName"
                  name="TeamName"
                  label="Your Team Name"
                  margin="normal"
                  placeholder="Enter Team Name"
                  className="input"
                  onChange={formik.handleChange}
                  value={formik.values.TeamName}
                  error={
                    formik.touched.TeamName && Boolean(formik.errors.TeamName)
                  }
                  helperText={formik.touched.TeamName && formik.errors.TeamName}
                />
              </div>

              <div className="innerGroup">
                <p>ADD Team Members</p>
                <Autocomplete
                  className="input"
                  limitTags={3}
                  id="multiple-limit-tags"
                  options={getstudents}
                  multiple
                  getOptionLabel={(option) => `${option.std_id}`}
                  value={formik.values.TeamMember}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("TeamMember", [...newValue]);}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select"
                      placeholder="Select Team Members"
                    />
                  )}
                  sx={{ width: "500px" }}
                />
              </div>

              {/* Posters preview */}
              {/* {posterPreviews.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <p>Generated Posters:</p>
                  <small style={{ color: "green" }}>
                    Your team posters are ready! 🎉 Download and share them on social media to showcase your participation.
                  </small>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", marginTop: "20px" }}>
                    {posterPreviews.map((p, idx) => (
                      <div
                        key={idx}
                        style={{
                          border: "1px solid #ccc",
                          padding: "10px",
                          borderRadius: "8px",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={p.url}
                          alt="poster"
                          style={{ width: "200px", borderRadius: "6px" }}
                        />
                        <div>
                          <IconButton
                            color="primary"
                            onClick={() =>
                              downloadFile(p.file, `${p.student.std_name}-Poster.png`)
                            }
                          >
                            <DownloadIcon />
                          </IconButton>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )} */}

              <LoadingButton
                loading={loadingbtn}
               
                variant="contained"
                type="submit"
                sx={{
                  mt: 2,
                  backgroundColor: "#AB509D",
                  color: "white",
                  "&:disabled": { backgroundColor: "#ccc" },
                }}
              >
                Next
              </LoadingButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
